import React from 'react';
import { Switch as NativeSwitch } from 'react-native';

import { common, designSystem } from '@/styles/styles';
import { isIos } from '@/utils/constants-platform-specific';

import { Switch } from './Switch';
import { ds } from './lib/design.system';

type CustomSwitchType = {
    val: boolean;
    handleOnPress: () => void;
};

export const CustomSwitch = ({ val, handleOnPress }: CustomSwitchType) => {
    return isIos ? (
        <Switch val={val} handleOnPress={handleOnPress} />
    ) : (
        <NativeSwitch
            trackColor={{ false: designSystem.colors.neutral200, true: ds.colorValue.background.success.strong }}
            thumbColor={ds.colorValue.background.neutral.inverse}
            onValueChange={handleOnPress}
            value={val}
            style={common.switchSize}
        />
    );
};
